import { tailwindColors } from '@repo/tailwind-config/tailwind.vars'
import { AvailableLanguages } from '@repo/toolkit/language-types'
import { BalloonIcon, BuildingTwoIcon, TeacherIcon } from '@repo/ui/icons'
import { TFunction } from 'i18next'
import { ReactNode } from 'react'

import { AccordionState } from '../../../../lib/types/utils'

export type CenterProgramAccordionKey = 'program-details' | 'tefl' | 'teaching-hall'

export const getCenterProgramAccordionState = (
  t: TFunction<AvailableLanguages, undefined>,
  actions: Partial<Record<CenterProgramAccordionKey, ReactNode>>
): AccordionState<CenterProgramAccordionKey>[] => [
  {
    key: 'program-details',
    label: t('ol.center.program.activities.planner.title'),
    open: true,
    icon: <BalloonIcon color={tailwindColors.secondary.DEFAULT} />,
    actions: actions['program-details']
  },
  {
    key: 'tefl',
    label: t('ol.center.program.activities.tefl.table.name'),
    open: true,
    icon: <TeacherIcon color={tailwindColors.secondary.DEFAULT} />
  },
  {
    key: 'teaching-hall',
    label: t('ol.center.program.activities.teaching.hall.table.name'),
    open: true,
    icon: <BuildingTwoIcon color={tailwindColors.secondary.DEFAULT} />
  }
]
